module.exports = __webpack_public_path__ + "static/media/safetyInfoDE.46d89c64.pdf";